import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import "./nonUpdatedContracts.css";
import Header from "../../../COMPONENTS/header/Header";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";

function NonUpdatedContracts() {
    const [nonUpdatedContracts, setNonUpdatedContracts] = useState([]);
    const navigate = useNavigate();
    const { auth } = useContext(AuthContext);
    const subscribername = auth.subscriberName;
    const digitalLendor = auth.digitalLendor;
    const staff = auth.staff;

    useEffect(() => {
        if (staff === "Yes" || subscribername === "BANK OF TANZANIA") {
            axios
                .get("/api/nonUpdated-Contracts")
                .then((response) => {
                    // Filter the data on the client-side based on the subscriberName
                    const dataResponse = response.data.map((subscribers, index) => ({
                        ...subscribers,
                        rowNumber: index + 1,

                    }));
                    setNonUpdatedContracts(dataResponse);
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            axios
                .get("/api/nonUpdated-Contracts")
                .then((response) => {
                    // Filter the data on the client-side based on the subscriberName
                    const dataResponse = response.data
                        .filter(
                            (subscribers) => (subscribers["Subscriber Name"] === subscribername || subscribers["Subscriber Name"] === digitalLendor)
                        )
                        .map((subscribers, index) => ({
                            ...subscribers,
                            rowNumber: index + 1,
                        }));
                    setNonUpdatedContracts(dataResponse);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [subscribername, staff, digitalLendor]);

    const handleView = (
        phaseofcontract,
        typeofcontract,
        ContractStatusId,
        TotalAmount,
        TotalTakenAmount,
        FullName,
        ContractCode,
        CustomerCode,
        CompanyName,
        StartDate,
        OutstandingAmount,
        PastDueAmount,
        PastDueDays,
        ExpectedEndDate,
        LastSnapshotDate,
        Subscriber
    ) => {
        const nonUpdatedContractDetails = {
            phaseofcontract,
            typeofcontract,
            ContractStatusId,
            TotalAmount,
            TotalTakenAmount,
            FullName,
            ContractCode,
            CustomerCode,
            CompanyName,
            StartDate,
            OutstandingAmount,
            PastDueAmount,
            PastDueDays,
            ExpectedEndDate,
            LastSnapshotDate,
            Subscriber
        };
        navigate("/ViewNonUpdatedContract", { state: { nonUpdatedContractDetails } });
    };

    const columns = [
        {
            field: "rowNumber",
            headerName: "#",
            flex: 0.1,
        },
        {
            field: "phaseofcontract",
            headerName: "Contract Phase",
            flex: 0.6,
        },
        {
            field: "typeofcontract",
            headerName: "Contract type",
            flex: 0.6,
        },
        {
            field: "TotalTakenAmount",
            headerName: "Amount Taken",
            flex: 0.6,
        },
        {
            field: "FullName",
            headerName: "Full Name",
            flex: 1,
        },
        {
            field: "CustomerCode",
            headerName: "Customer Code",
            flex: 0.7,
        },
        {
            field: "CompanyName",
            headerName: "Company Name",
            flex: 0.7,
        },
        {
            field: "Subscriber",
            headerName: "Subscriber Name",
            flex: 0.7,
        },
        {
            field: "action",
            headerName: "Action",
            flex: 0.5,
            renderCell: (params) => {
                return (
                    <>
                        <button
                            className="viewnonUpdatedContractButton"
                            onClick={() =>
                                handleView(
                                    params.row.phaseofcontract,
                                    params.row.typeofcontract,
                                    params.row.ContractStatusId,
                                    params.row.TotalAmount,
                                    params.row.TotalTakenAmount,
                                    params.row.FullName,
                                    params.row.ContractCode,
                                    params.row.CustomerCode,
                                    params.row.CompanyName,
                                    params.row.StartDate,
                                    params.row.OutstandingAmount,
                                    params.row.PastDueAmount,
                                    params.row.PastDueDays,
                                    params.row.ExpectedEndDate,
                                    params.row.LastSnapshotDate,
                                    params.row.Subscriber
                                )
                            }
                        >
                            View
                        </button>
                    </>
                );
            },
        },
    ];
    return (
        <div className="app">
            <MyProSidebar />
            <main className="content">
                <Topbar />
                <Box m="8px">
                    <Box m="8px">
                        <Header
                            title="NON UPDATED CONTRACTS"
                            subtitle="View all non updated contracts"
                        />
                        <Box
                            m="40px 0 0 0"
                            height="100vh"
                            sx={{
                                "& .MuiDataGrid-root": {
                                    border: "none",
                                },
                                "& .MuiDataGrid-cell": {
                                    borderBottom: "none",
                                },
                                "& .name-column--cell": {
                                    color: "#2e7c67",
                                },
                                "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: "#bbbbbb",
                                    borderBottom: "none",
                                },
                                "& .MuiDataGrid-virtualScroller": {
                                    backgroundColor: "#f2f0f0",
                                },
                                "& .MuiDataGrid-footerContainer": {
                                    borderTop: "none",
                                    backgroundColor: "#a4a9fc",
                                },
                                "& .MuiCheckbox-root": {
                                    color: `${"#1e5245"} !important`,
                                },
                                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                    color: `${"#525252"} !important`,
                                },
                            }}
                        >
                            <DataGrid
                                rows={nonUpdatedContracts}
                                columns={columns}
                                components={{ Toolbar: GridToolbar }}
                            />
                        </Box>
                    </Box>
                </Box>
            </main>
        </div>
    );
}

export default NonUpdatedContracts;
